import Bowser from 'bowser';

export const useUserAgent = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const platform = browser.getPlatform();

  return { 
    isMobile: platform.type === 'mobile',
    isDesktop: platform.type === 'desktop',
  };
};